import { jsx as s, jsxs as o, Fragment as B } from "react/jsx-runtime";
import { useState as H, useEffect as O } from "react";
import { useTranslation as $ } from "react-i18next";
import _ from "classnames";
import P from "../../../../icons/ChevronRightIcon.js";
import R from "../../../../icons/FavouritesIcon.js";
import U from "../DragItem/index.js";
import b from "../DropItem/index.js";
import { getListItemIcon as q } from "../utils.js";
import { s as e } from "../../../../explorer-list-item.module-DIjfI1HF.js";
const g = (r, a) => r.type === "folder" && a.includes(r.translatedName), z = ({
  item: r,
  active: a = [],
  updated: h,
  selected: i,
  over: m,
  onToggleMenu: c,
  isModalOpen: v,
  parent: l,
  editing: p,
  actions: u,
  optionsState: n,
  className: F,
  showEmptyText: L,
  isInGroup: j,
  contextMenu: f
}) => {
  var C, D, E;
  const { t: w } = $(), [N, I] = H(g(r, a) || !1), [G, t] = H(!1), { onClickItem: y } = u, { onFavouritesToggle: k } = p ?? {};
  O(() => {
    g(r, a) && I(!0);
  }, [a]);
  const x = () => {
    y && y(r, l && { id: l.id, name: l.name, translatedName: l.translatedName }, j), r.type === "folder" && I((d) => !d);
  }, A = q(r);
  return /* @__PURE__ */ s(
    b,
    {
      id: r.id,
      dropId: r.id,
      name: r.name,
      type: r.type,
      className: e.container,
      children: /* @__PURE__ */ o(B, { children: [
        /* @__PURE__ */ s(
          U,
          {
            id: r.id,
            folderId: (l == null ? void 0 : l.id) ?? null,
            name: r.name,
            type: r.type,
            isUpdated: h === r.id,
            isMenuOpen: (n == null ? void 0 : n.itemId) === r.id,
            isModalOpen: v,
            children: /* @__PURE__ */ o(
              "div",
              {
                id: `file_explorer_template_${r.id}`,
                className: _(
                  e.root,
                  (i == null ? void 0 : i.includes(r.id)) && e.selected,
                  (n == null ? void 0 : n.moveToItemId) === r.id && e.moveHover,
                  N && e.open,
                  m === r.id && e.moveHover,
                  `file-explorer-${r.type}`,
                  F
                ),
                onMouseEnter: () => t(!0),
                onMouseLeave: () => t(!1),
                children: [
                  r.type === "folder" && ((C = r.children) == null ? void 0 : C.length) && /* @__PURE__ */ o(
                    "div",
                    {
                      className: e.arrowButton,
                      onClick: x,
                      onContextMenu: (d) => {
                        c && (d.preventDefault(), c(r.id));
                      },
                      children: [
                        /* @__PURE__ */ s("div", { className: e.count, children: ((D = r.children) == null ? void 0 : D.length) ?? 0 }),
                        /* @__PURE__ */ s(P, { className: e.arrowIcon })
                      ]
                    }
                  ),
                  /* @__PURE__ */ o(
                    "div",
                    {
                      className: e.content,
                      onClick: x,
                      onContextMenu: (d) => {
                        c && (d.preventDefault(), c(r.id));
                      },
                      children: [
                        /* @__PURE__ */ s(
                          "img",
                          {
                            className: e.icon,
                            src: A,
                            alt: ""
                          }
                        ),
                        /* @__PURE__ */ o("div", { className: e.name, children: [
                          r.name.replaceAll(/<[^>]*>/g, ""),
                          L && r.type === "folder" && !((E = r.children) != null && E.length) && !r.external && /* @__PURE__ */ s("span", { className: e.nameEmpty, children: w("empty_folder") })
                        ] })
                      ]
                    }
                  ),
                  /* @__PURE__ */ o("div", { className: e.buttons, children: [
                    /* @__PURE__ */ s(
                      R,
                      {
                        className: _(e.fave, r.favorite && e.checked),
                        onClick: (d) => {
                          d.preventDefault(), d.stopPropagation(), k && (r.external || k({ id: r.id, type: r.type, checked: !r.favorite }));
                        }
                      }
                    ),
                    f && /* @__PURE__ */ s("div", { className: e.optionsButton, children: f(r, l) })
                  ] })
                ]
              }
            )
          }
        ),
        N && r.children && /* @__PURE__ */ s("div", { className: e.children, children: r.children.map((d) => /* @__PURE__ */ s(
          z,
          {
            item: d,
            parent: {
              id: r.id,
              name: r.name,
              translatedName: r.translatedName,
              parentId: l == null ? void 0 : l.id
            },
            active: a,
            updated: h,
            selected: i,
            over: m,
            onToggleMenu: c,
            isModalOpen: v,
            editing: p,
            actions: u,
            optionsState: n,
            contextMenu: f
          },
          d.id
        )) })
      ] })
    }
  );
};
export {
  z as default
};
